import React, { useEffect, useState } from "react";

import {
  collection,
  onSnapshot,
  orderBy,
  query,
  limit,
  doc,
  updateDoc,
} from "firebase/firestore";

import {
  FaBell,
  FaCheckCircle,
  FaUser,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";

import { db } from "../../firebase/firebase";

import "./NotificationBell.css";

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);

  // ==========================================
  // LOAD QUOTE REQUESTS
  // ==========================================

  useEffect(() => {
    const quoteRef = collection(db, "quoteRequests");

    const quoteQuery = query(quoteRef, orderBy("createdAt", "desc"), limit(10));

    const unsubscribe = onSnapshot(
      quoteQuery,
      (snapshot) => {
        const data = snapshot.docs.map((item) => ({
          id: item.id,
          ...item.data(),
        }));

        setNotifications(data);
      },
      (error) => {
        console.error("Notification loading error:", error);
      },
    );

    return () => unsubscribe();
  }, []);

  // ==========================================
  // UNREAD COUNT
  // ==========================================

  const unreadCount = notifications.filter((item) => item.read !== true).length;

  // ==========================================
  // MARK NOTIFICATION AS READ
  // ==========================================

  const markAsRead = async (id) => {
    try {
      await updateDoc(doc(db, "quoteRequests", id), {
        read: true,
      });
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  // ==========================================
  // FORMAT DATE
  // ==========================================

  const formatDate = (timestamp) => {
    if (!timestamp) {
      return "Just now";
    }

    try {
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

      return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return "Just now";
    }
  };

  return (
    <div className="notification-wrapper">
      {/* ======================================
          BELL BUTTON
      ====================================== */}

      <button
        type="button"
        className="notification-bell"
        onClick={() => setOpen((previous) => !previous)}
        aria-label="Notifications"
      >
        <FaBell />

        {unreadCount > 0 && (
          <span className="notification-count">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>

      {/* ======================================
          NOTIFICATION PANEL
      ====================================== */}

      {open && (
        <div className="notification-panel">
          {/* HEADER */}

          <div className="notification-header">
            <div>
              <h3>Notifications</h3>

              <span>{unreadCount} unread</span>
            </div>

            <FaBell />
          </div>

          {/* ==================================
              EMPTY
          ================================== */}

          {notifications.length === 0 ? (
            <div className="notification-empty">
              <FaCheckCircle />

              <h4>No notifications</h4>

              <p>New quote requests will appear here.</p>
            </div>
          ) : (
            <div className="notification-list">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-item ${
                    notification.read ? "read" : "unread"
                  }`}
                  onClick={() => markAsRead(notification.id)}
                >
                  {/* ICON */}

                  <div className="notification-icon">
                    <FaUser />
                  </div>

                  {/* CONTENT */}

                  <div className="notification-content">
                    <div className="notification-title-row">
                      <h4>New Quote Request</h4>

                      {!notification.read && (
                        <span className="unread-dot"></span>
                      )}
                    </div>

                    <p className="notification-name">
                      {notification.name || "New Customer"}
                    </p>

                    <div className="notification-contact">
                      {notification.phone && (
                        <span>
                          <FaPhone />
                          {notification.phone}
                        </span>
                      )}

                      {notification.email && (
                        <span>
                          <FaEnvelope />
                          {notification.email}
                        </span>
                      )}
                    </div>

                    <small>{formatDate(notification.createdAt)}</small>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
